import React, { useState, useEffect } from "react";

import HomeImg from "../../assets/shopdefault.png";

import axios from "axios";
import { server } from "../../utills/utils";

import Order from "./Orders/Order/PendingOrder";

import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
`;
const HomeHeader = styled.div`
  width: 90%;
  height: 32%;
  background: #f5f5f5;
  padding: 3.5% 5%;
  border-radius: 5px;
`;
const ShopDetails = styled.div`
  width: 100%;
  height: 40%;
`;
const DetailsLeft = styled.div`
  width: 80%;
  height: 100%;
  float: left;
`;
const ShopName = styled.h2`
  font-size: 1.3em;
  font-weight: 500;
  margin: 0;
  padding: 3px 0;
`;
const ShopLocation = styled.p`
  margin: 0;
  padding: 0;
  font-weight: 500;
`;
const ShopPhone = styled.p`
  margin: 0;
  padding: 2px 0;
  font-size: 0.9em;
  color: gray;
`;
const ShopCards = styled.div`
  width: 100%;
  height: 55%;
  margin-top: 20px;
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
`;
const Card1 = styled.div`
   {
    width: 31%;
    height: 100%;
    background: #ff7e7e;
    border-radius: 5px;
  }
`;
const Card2 = styled.div`
   {
    width: 31%;
    height: 100%;
    background: #b17dff;
    border-radius: 5px;
  }
`;
const Card3 = styled.div`
   {
    width: 31%;
    height: 100%;
    background: #bae52a;
    border-radius: 5px;
  }
`;
const CardValue = styled.h1`
  margin: 0;
  padding: 7% 0 4% 7%;
  color: white;
  font-size: 1.5em;
`;
const CardName = styled.p`
  margin: 0;
  padding: 0 7%;
  font-size: 1.2em;
  color: white;
`;

const RecentSales = styled.div`
  width: 90%;
  height: 52%;
  background: #f5f5f5;
  margin-top: 10px;
  padding: 1% 5%;
  border-radius: 5px;
`;

const SaleTitle = styled.h2`
  font-size: 1.2em;
  font-weight: 500;
  margin: 0;
  padding: 10px 0 3px 0;
`;
const SaleDate = styled.p`
  font-size: 1em;
  font-weight: 400;
  margin: 0;
  padding: 0 0 10px 0;
  color: gray;
`;
const CoverImg = styled.img`
  width: 100%;
  height: 280px;
  border-radius: 5px;
  margin-top: 30px;
`;

function Home() {
  const [shop, setShop] = useState({});
  const [complete, setComplete] = useState(false);

  const fetchShop = async (args, req) => {
    const shop = await axios.post(server, {
      query: `
              query{
                shop(shopId:"${localStorage.shopId}"){
                  name
                  location
                  cityName
                  thanaName
                  phone
                  adminProducts
                  deliveredOrders
                  pendingOrders
                  categoryId
                }
              }
            `,
    });
    console.log("Shop", shop);
    setShop(shop.data.data.shop);
    setComplete(true);
  };

  useEffect(() => {
    fetchShop();
  }, []);
  return (
    <div style={{ width: "100%", height: "100%" }}>
      {complete ? (
        <Container>
          <HomeHeader>
            <ShopDetails>
              <DetailsLeft>
                <ShopName>{shop.name}</ShopName>
                <ShopLocation>
                  Location : {shop.cityName} {shop.thanaName}
                </ShopLocation>
                <ShopPhone>Phone: {shop.phone}</ShopPhone>
              </DetailsLeft>
            </ShopDetails>
            <ShopCards>
              <Card1>
                <CardValue>{shop.adminProducts.length}</CardValue>
                <CardName>
                  {shop.categoryId != "6129e467f8785a2974c9915a"
                    ? "Product Types"
                    : "Service Types"}
                </CardName>
              </Card1>
              <Card2>
                <CardValue>{shop.deliveredOrders.length}</CardValue>
                <CardName>Sales</CardName>
              </Card2>
              <Card3>
                <CardValue>{shop.pendingOrders.length}</CardValue>
                <CardName>Pending Orders</CardName>
              </Card3>
            </ShopCards>
          </HomeHeader>
          {/* <RecentSales>
           
        </RecentSales> */}
          <CoverImg src={HomeImg} alt="cover" />
        </Container>
      ) : (
        <p>Loading....</p>
      )}
    </div>
  );
}

export default Home;
